declare global {
  /* eslint-disable unused-imports/no-unused-vars */
  interface Window {
    uetq: any[];
  }
}

export function bingUET(conversionBtn: string) {
  if (
    process.env.NEXT_PUBLIC_ENABLE_TRACKING &&
    process.env.NEXT_PUBLIC_ENABLE_TRACKING !== 'false'
  ) {
    window.uetq = window.uetq || [];
    window.uetq.push({
      ec: 'button',
      ea: 'click',
      el: conversionBtn,
      ev: '0',
    });
  }
}
